import script from './component-lib.esm6.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('ul', {
    staticClass: "site__footer-social",
    class: _vm.classes
  }, [_vm._l(_vm.socialAccounts, function (account) {
    return [account.url ? _c('li', {
      key: account._id.$oid
    }, [_c('a', {
      attrs: {
        "href": _vm.getSocialAccountUrl(account),
        "target": "_blank"
      }
    }, [_c(_vm.getSocialIconComponentName(account.type), {
      tag: "component"
    })], 1)]) : _vm._e()];
  })], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-5b559ae7_0", {
    source: ".site__footer-social[data-v-5b559ae7]{--icon-padding:0.425rem;align-items:center;display:flex;flex-wrap:wrap;list-style:none;justify-content:center;position:relative;margin:1.25rem 0 0;padding:0;row-gap:.425rem;column-gap:.75rem}.site__footer-social--top[data-v-5b559ae7]{margin-bottom:-.325rem;margin-top:.75rem}.site__footer-social a[data-v-5b559ae7]{color:var(--p-social-color);display:inline-flex;font-size:1.925rem;padding:var(--icon-padding);transition:transform var(--g-transition-speed) cubic-bezier(.4,0,.2,1)}.site__footer-social a[data-v-5b559ae7]:focus,.site__footer-social a[data-v-5b559ae7]:hover{color:var(--p-social-color);transform:scale(1.1)}.site__footer-social a svg[data-v-5b559ae7]{flex-shrink:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-5b559ae7";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var SocialAccounts = __vue_component__;
export { SocialAccounts as default };